module.exports = __webpack_public_path__ + "static/media/logo.131170fd.png";